import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex mb-5 justify-between items-center gap-3 border-b border-secondary" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "py-2 text-3xl font-bold text-gray-700" }
const _hoisted_4 = {
  key: 0,
  class: "ml-2 text-xs text-white bg-secondary opacity-80 px-2 py-1 rounded font-bold"
}



interface Props {
    title?: string;
    study?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskHeader',
  props: {
    title: {},
    study: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.study)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.study), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})